import React, { useState, useEffect } from 'react';
import { Form, Input, Card, Button, Select, Row, Col, UploadProps, Typography, Upload, message } from 'antd';
import { Link, useHistory } from "react-router-dom";
import { AlertMessages } from '@gtpl/shared-utils/alert-messages';
import { LoadingOutlined } from '@ant-design/icons';

// import './spec-sheet-form.css';
import form from 'antd/lib/form';
import { CustomerDto, MasterBrandsDropDownDto, SkuDto, SpecSheetDto, UploadFileName } from '@gtpl/shared-models/masters';
import { CustomersService, MasterBrandService, SkuService, SpecSheetService } from '@gtpl/shared-services/masters';
import { UploadOutlined, PlusOutlined } from '@ant-design/icons';
import appSettings from 'apps/services/config';
import moment from 'moment';
import { GrnService } from '../../../../../../shared-services/procurement/src/lib/grn-service'
import { PurchaseOrderService } from '../../../../../../shared-services/procurement/src/lib/purchase-order.service'
import { GrnDto } from 'libs/shared-models/procurement-management/src/lib/grn/grn.dto';
import { SaleOrderService } from 'libs/shared-services/sale-management/src/lib/saleorder-services';
import {PoFileUploadDto} from '../../../../../../shared-models/procurement-management/src/lib/purchase-order/po-file-upload.dto'


/* eslint-disable-next-line */
const { Option } = Select;
const layout = {
  labelCol: {
    span: 10,
  },
  wrapperCol: {
    span: 8,
  },
};


const tailLayout = {
  wrapperCol: {
    offset: 10,
    span: 10,
  },
};

/* eslint-disable-next-line */
export interface SpecSheetFormProps {
  poUploadData: PoFileUploadDto;
  updateItem: (poUploadData: PoFileUploadDto, filelist: any) => void;
  isUpdate: boolean;
  closeForm: () => void;
  // uploadFileList:(uploadFiles:any[])=>void
  // uploadedFile:string;


}

export function TallyUploadFiles(props: SpecSheetFormProps) {
  const [form] = Form.useForm();
  const [disable, setDisable] = useState<boolean>(false)
  const [uploadedFileName, setUploadedFileName] = useState<string>('');
  const [selectedCustomer, setselectedCustomer] = useState<number>(null);
  const [selectedbrand, setselectedbrand] = useState<number>(null);
  const [selectedvarient, setselectedvarient] = useState<number>(null);
  const [customerData, setcustomerData] = useState<CustomerDto[]>();
  const [brandData, setbrandData] = useState<MasterBrandsDropDownDto[]>();
  const [poNumberData, setpoNumberData] = useState<any[]>();

  const [varientData, setvarientData] = useState<SkuDto[]>();
  const [loading, setLoading] = useState<boolean>(false);
  // const [filelist, setFilelist] = useState([]);
  const [filelist, setFilelist] = useState<any>(props.isUpdate ? [{
    name: props.poUploadData.fileName,
    status: 'done',
    url: appSettings.file_upload_path + props.poUploadData.filePath,
  }] : []);

  const [selectedFileName, setSelectedFileName] = useState<any>(undefined);

  const [grnData, setgrnData] = useState<any[]>();
  const [poData, setpoData] = useState<any[]>();
  const [invoiceData, setinvoiceData] = useState<any[]>();


  const [selectedGrn, setSelectedGrn] = useState<any>(undefined);
  console.log(selectedGrn,'selectedGrn')
  const [selectedPoNumber, setSelectedPoNumber] = useState<any>(undefined);
  const [selectedInvoice, setSelectedInvoice] = useState<any>(undefined);






  const grnservice = new GrnService;
  const poNumberservice = new PurchaseOrderService
  const invoicenumberservice = new SaleOrderService

  useEffect(() => {
    getGrnData();
    getPoNumberData()
    getInvoiceNumberData()
  }, [])

  const getGrnData = () => {
    grnservice.getGrnData().then(res => {
      if (res.status) {
        setgrnData(res.data);
      } else {
        if (res.intlCode) {
          AlertMessages.getErrorMessage(res.internalMessage);
        } else {
          AlertMessages.getErrorMessage(res.internalMessage);
        }
      }
    }).catch(err => {
      AlertMessages.getErrorMessage(err.message);
    })

  }

  const getPoNumberData = () => {
    poNumberservice.getPoNumberData().then(res => {
      if (res.status) {
        setpoData(res.data);
      } else {
        if (res.intlCode) {
          AlertMessages.getErrorMessage(res.internalMessage);
        } else {
          AlertMessages.getErrorMessage(res.internalMessage);
        }
      }
    }).catch(err => {
      AlertMessages.getErrorMessage(err.message);
    })

  }

  const getInvoiceNumberData = () => {
    invoicenumberservice.getInvoiceNumberData().then(res => {
      if (res.status) {
        setinvoiceData(res.data);
      } else {
        if (res.intlCode) {
          AlertMessages.getErrorMessage(res.internalMessage);
        } else {
          AlertMessages.getErrorMessage(res.internalMessage);
        }
      }
    }).catch(err => {
      AlertMessages.getErrorMessage(err.message);
    })

  }

  

  let history = useHistory()
  const savePoUpload = (value) => {
    form.validateFields().then(req => {
      if(filelist.length >0){
        const formData = new FormData();
        filelist.forEach((file: any) => {
          formData.append('file', file);
        });
        formData.append('purchaseOrdrId', `${value.poNumber}`)
        poNumberservice.poFileUpload(formData).then(res => {
          console.log(res,'fileresfileresfileres')
          value.filePath = res.data;
          if(res.status){
            message.success(res.internalMessage)
            form.resetFields()
            setFilelist([])
          }
        })
      }
    })
  }

  const savegrnUpload = (value) => {
  console.log(value,'valuevaluevalue')
    form.validateFields().then(req => {
      if(filelist.length >0){
        const formData = new FormData();
        filelist.forEach((file: any) => {
          formData.append('file', file);
        });
        formData.append('grnId', `${value.grnInvoiceNumber}`)
        grnservice.grnFileUpload(formData).then(res => {
          value.filePath = res.data;
          if(res.status){
            message.success(res.internalMessage)
            form.resetFields()
            setFilelist([])
          }
        })
      }
    })
  }


  const saveInvoiceUpload = (value) => {
    console.log(value,'valuevaluevalue')
      form.validateFields().then(req => {
        if(filelist.length >0){
          const formData = new FormData();
          filelist.forEach((file: any) => {
            formData.append('file', file);
          });
          formData.append('invoiceId', `${value.invoiceNumber}`)
          invoicenumberservice.invoiceFileUpload(formData).then(res => {
            value.filePath = res.data;
            if(res.status){
              message.success(res.internalMessage)
              form.resetFields()
              setFilelist([])
            }
          })

        }
      })
    }


  const saveData = (values: PoFileUploadDto,documentType: string) => {
    console.log(values, 'dto in form')
    setDisable(false)
    if (props.isUpdate) {
      // form.setFieldsValue('fileUpload') == form.getFieldValue('fileUpload')
      setFilelist([]);
      props.updateItem(values, filelist);
    } else {
      setDisable(false)

      if (documentType===UploadFileName.PO){
      savePoUpload(values);
      }
      if (documentType===UploadFileName.GRN){
      savegrnUpload(values);
      }
      if(documentType===UploadFileName.INVOICE){
        saveInvoiceUpload(values)
      }
    }
    
  };

  const handlecustomer = (value) => {
    setselectedCustomer(value);
  }

  const handlevarient = (value) => {
    setselectedvarient(value);
  }
  const onFocus = () => {
    console.log('focus');
  }
  const onSearch = (val) => {
    console.log('search:', val);
  }
  const onBlur = () => {
    console.log('blur');
  }
  const onReset = () => {
    form.resetFields();
    setFilelist([]);
  };
  let createdUser = "";
  if (!props.isUpdate) {
    createdUser = localStorage.getItem("createdUser");
  }


  const uploadFieldProps: UploadProps = {
    multiple: false,
    onRemove: file => {
      setFilelist([]);
      // props.uploadFileList([])

    },
    beforeUpload: (file: any) => {
      if (!file.name.match(/\.(csv|xlsx|xls|pdf|zip)$/)) {
        AlertMessages.getErrorMessage("Only xlsx,csv,xls,pdf files are allowed!");
        return true;
      }
      var reader = new FileReader();
      reader.readAsArrayBuffer(file);
      reader.onload = data => {
        if (filelist.length == 1) {
          AlertMessages.getErrorMessage("You cannot upload more than One file at a time");
          return true;
        } else {
          setFilelist([...filelist, file]);
          // props.uploadFileList([...filelist, file])
          return false;
        }
      }
    },
    progress: {
      strokeColor: {
        '0%': '#108ee9',
        '100%': '#87d068',
      },
      strokeWidth: 3,
      format: percent => `${parseFloat(percent.toFixed(2))}%`,
    },
    fileList: filelist
  };

  const handleFileNameChange = (value: UploadFileName) => {
    console.log(value, 'kkk')
    setSelectedFileName(value);
  };

  const handelGrnChange = (value) => {
    setSelectedGrn(value);
  };

  const handelPoNumberChange = (value) => {
    setSelectedPoNumber(value)
  }

  const handelInvoiceChange = (value) => {
    setSelectedInvoice(value)
  }



  return (
    <>
      <Card title={<span style={{ color: 'white' }}>File Uploads</span>}
        style={{ textAlign: 'center' }} headStyle={{ backgroundColor: '#69c0ff', border: 0 }} extra={props.isUpdate == true ? "" : <Link to='tally-files-view' ><span style={{ color: 'white' }} ><Button className='panel_button' >View </Button> </span></Link>} >
        <Form form={form} initialValues={props.poUploadData} name="control-hooks"
         onFinish={(values) => saveData(values, selectedFileName)}
          layout="vertical"
        >
          <Form.Item name="purchaseOrderId" style={{ display: "none" }} >
            <Input hidden />
          </Form.Item>
          <Form.Item style={{ display: "none" }} name="createdUser" initialValue={createdUser}>
            <Input hidden />
          </Form.Item>
          <Row>
            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5, offset: 1 }} lg={{ span: 5, offset: 1 }} xl={{ span: 5, offset: 1 }} style={{ margin: '1%' }}>

              <Form.Item name="document" label="Document"
                rules={[
                  {
                    required: true, message: 'Missing Document',
                  },
                ]}>
                <Select
                  id="document"
                  placeholder='Select Document'
                  value={selectedFileName}
                  onChange={handleFileNameChange}
                >
                  <Option value={UploadFileName.PO}>PO</Option>
                  <Option value={UploadFileName.INVOICE}>INVOICE</Option>
                  <Option value={UploadFileName.GRN}>GRN</Option>


                </Select>
              </Form.Item>
            </Col>
            {selectedFileName === UploadFileName.GRN ?
              <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5 }} lg={{ span: 6 }} xl={{ span: 4 }} style={{ margin: '1%' }} >
                <Form.Item
                  name="grnInvoiceNumber"
                  label="GRN"
                  rules={[
                    {
                      required: true,
                      message: 'GRN  is required'
                    },
                    // {
                    //   pattern: /^(?!\s*$).+/,
                    //   message: `Select the GRN`
                    // }
                  ]}

                >
                  <Select
                    showSearch
                    //style={{ width: 200 }}
                    placeholder="Select GRN"
                    value={selectedGrn}
                    onChange={handelGrnChange}
                    optionFilterProp="children"
                    onFocus={onFocus}
                    onBlur={onBlur}
                    onSearch={onSearch}
                    filterOption={(input, option) =>
                      option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                  >
                    {/* <Option >Select GRN</Option> */}
                    {grnData?.map((value) => {
                      return <Option key={value.inv_no} value={value.grn_id}>{value.inv_no}</Option>
                    })}
                  </Select>
                </Form.Item>
              </Col> : <></>}






            {selectedFileName === UploadFileName.PO ?
              <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5 }} lg={{ span: 6 }} xl={{ span: 4 }} style={{ margin: '1%' }} >
                <Form.Item
                  name="poNumber"
                  label="PO Number"
                  rules={[
                    {
                      required: true,
                      message: 'PO Number  is required'
                    },
                    // {
                    //   pattern: /^(?!\s*$).+/,
                    //   message: `Select the PO Number`
                    // }
                  ]}

                >
                  <Select
                    showSearch
                    //style={{ width: 200 }}
                    placeholder="Select PO Number"
                    value={selectedPoNumber}
                    onChange={handelPoNumberChange}
                    optionFilterProp="children"
                    onFocus={onFocus}
                    onBlur={onBlur}
                    onSearch={onSearch}
                    filterOption={(input, option) =>
                      option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                  >
                    {/* <Option >Select GRN</Option> */}
                    {poData?.map((value) => {
                      return <Option key={value.po_number} value={value.purchase_order_id}>{value.po_number}</Option>
                    })}
                  </Select>
                </Form.Item>
              </Col> : <></>}


            {selectedFileName === UploadFileName.INVOICE ?
              <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5 }} lg={{ span: 6 }} xl={{ span: 4 }} style={{ margin: '1%' }} >
                <Form.Item
                  name="invoiceNumber"
                  label="Invoice Number"
                  rules={[
                    {
                      required: true,
                      message: 'Invoice Number  is required'
                    },
                    // {
                    //   pattern: /^(?!\s*$).+/,
                    //   message: `Select the Invoice Number`
                    // }
                  ]}

                >
                  <Select
                    showSearch
                    //style={{ width: 200 }}
                    placeholder="Select Invoice Number"
                    value={selectedInvoice}
                    onChange={handelInvoiceChange}
                    optionFilterProp="children"
                    onFocus={onFocus}
                    onBlur={onBlur}
                    onSearch={onSearch}
                    filterOption={(input, option) =>
                      option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                  >
                    {/* <Option >Select GRN</Option> */}
                    {invoiceData?.map((value) => {
                      return <Option key={value.invoice_number} value={value.invoice_id}>{value.invoice_number}</Option>
                    })}
                  </Select>
                </Form.Item>
              </Col> : <></>}
            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5 }} lg={{ span: 4 }} xl={{ span: 4 }} style={{ margin: '1%' }}>
              <Form.Item name="fileUpload"
                rules={[
                  {
                    required: true,
                    message: 'File is Required'
                  }
                ]}
              >
                <Upload {...uploadFieldProps} style={{ padding: '7px' }}>
                  <br /><span style={{ color: "red" }}>*<Button style={{ color: "black", backgroundColor: "#7ec1ff" }} icon={<UploadOutlined />}>Upload File</Button></span><Typography.Text type="secondary">
                    (Supported formats xlsx,csv,xls,pdf,zip)
                  </Typography.Text>
                </Upload>
              </Form.Item>

            </Col>
          </Row>
          <Row>
            <Col span={24} style={{ textAlign: 'right' }}>
              <Button type="primary" htmlType="submit" >
                Submit
              </Button>
              {(props.isUpdate === false) &&
                <Button htmlType="button" style={{ margin: '0 14px' }} onClick={onReset}>
                  Reset
                </Button>
              }
            </Col>
          </Row>
        </Form>
      </Card>
    </>
  )
}

export default TallyUploadFiles;
